import { Modal } from "react-bootstrap";
import placeholderImage from "../../../../images/placeholder-image.png";
import ModifierCategoryChildProductCombo from "./ModifierCategoryChildProductCombo.js";
import ErrorAlert from "../../../../common/ui/ErrorAlert.js";
import * as CommonUtilities from "../../../../common/utils/CommonUtils.js";

export default function ProductComboChildModalPage(props) {
    // Details of Product that will be added into a group within a Product Combo

    let instrIsInvalid = "";
    if (props.productComboChildFormData.validation.SpecialInstructions.HasError) {
        instrIsInvalid = "is-invalid";
    } else {
        instrIsInvalid = "";
    }

    let energyCount;
    if (props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount !== 0 && props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount !== "0" && props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount !== "" && props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount !== null) {
        energyCount = <span className="badge bg-secondary bg-opacity-50">{props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount}kJ</span>
    } else {
        energyCount = <></>
    }


    let modifierCategories;
    modifierCategories = props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.modCategories?.map((item) => {
        return (
            <ModifierCategoryChildProductCombo 
                key={item.modCategoryId}
                modifierCategoryDetails={item}
                handleProductComboModFormChange={props.handleProductComboModFormChange}
                productComboChildFormData={props.productComboChildFormData}
                productFormDataMods={props.productComboChildFormData.data.Mods} // Passing as productFormDataMods from productComboChildFormData
                productFormDataModCatValidation={props.productComboChildFormData.validation.ModCategories} // Passing as productFormDataModCatValidation
                addToProductComboError={props.addToProductComboError}
                currentLocation={props.currentLocation}
                priceInc={props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.priceInc}
            />
        )
    });

    let specialInstructions, priceDisplay;
    if (CommonUtilities.StaticFields.PriceType == "bp8826") {
        // Bulk Pricing
        specialInstructions = <></>
        priceDisplay = <></>
    } else {
        specialInstructions = <div className="col-12 justify-content-center mx-auto form-floating mb-3">
                                <textarea className={`form-control ${instrIsInvalid}`} id="txtareaSpecialInstr" name="SpecialInstructions" value={props.productComboChildFormData.data.SpecialInstructions} onChange={props.handleProductComboChildFormChange} disabled={props.addToProductComboError.ButtonsDisabled} maxLength="32"></textarea>
                                <label htmlFor="txtareaSpecialInstr">Special Instructions</label>
                                <small className="invalid-feedback">{props.productComboChildFormData.validation.SpecialInstructions.ErrorMessage}</small>
                            </div>
        priceDisplay = <b className="mt-3">{CommonUtilities.StaticFields.CurrencySymbol}{props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.priceInc && props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.priceInc.toFixed(2)}</b>
    }

    return(
        <>
            <Modal.Body>
                <div className="row">
                    <div className="col-4">
                        <img src={props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.productImageURL ? props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.productImageURL : placeholderImage} className="rounded-3 float-end my-2 w-100 shadow-sm" style={{objectFit: "cover", objectPosition: "center center", aspectRatio: "1/1", maxWidth: "300px", minWidth: "70px"}} alt="Product"></img>
                    </div>
                    <div className="col-8 d-flex flex-column justify-content-between">
                        <div className="d-flex flex-column text-break">
                            <div>
                                <b className="me-2">{props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.productName}</b>{energyCount}
                            </div>
                            {props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.productDescription && <span>{props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.productDescription}</span>}
                        </div>
                        {priceDisplay}
                    </div>
                    {modifierCategories}
                </div>
            </Modal.Body>
            <Modal.Footer>
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && !props.productComboChildDetails.selectedProductDetails.isSoldOut && 
                    specialInstructions
                }
                { props.addToProductComboError.HasError && <div className="px-1 mx-auto mb-3 col-12"><ErrorAlert message={props.addToProductComboError.ErrorMessage} /></div> }
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && !props.productComboChildDetails.selectedProductDetails.isSoldOut && 
                    <div className="col-12 d-flex justify-content-center mx-auto">
                        <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleAddToProductCombo} disabled={props.addToProductComboError.ButtonsDisabled}>
                            Add to Combo
                            {props.addToProductComboError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></>}
                        </button>
                    </div>
                }
            </Modal.Footer>
        </>
    )
}